export const DASH_RECENT_ORDERS_GRID_CONFIG_ID = 'dash-recent-orders'

export const DASH_RECENT_ORDERS_GRID_CONFIG = {
  id: DASH_RECENT_ORDERS_GRID_CONFIG_ID,
  layout: {
    xl: { i: DASH_RECENT_ORDERS_GRID_CONFIG_ID, x: 4, y: 0, w: 3.5, h: 3, static: true },
    lg: { i: DASH_RECENT_ORDERS_GRID_CONFIG_ID, x: 4.5, y: 0, w: 4.5, h: 3, static: true },
    md: { i: DASH_RECENT_ORDERS_GRID_CONFIG_ID, x: 0, y: 3, w: 5, h: 3, static: true },
    sm: { i: DASH_RECENT_ORDERS_GRID_CONFIG_ID, x: 4, y: 3, w: 8, h: 3, static: true },
    xs: { i: DASH_RECENT_ORDERS_GRID_CONFIG_ID, x: 0, y: 4.25, w: 12, h: 3, static: true },
    xxs: { i: DASH_RECENT_ORDERS_GRID_CONFIG_ID, x: 0, y: 3.75, w: 12, h: 2.7, static: true }
  }
}
